import { GROUP_UPDATE, GROUP_REMOVE } from './group.actions';
import { AGENDA_LOGGED_OUT } from '../agenda/agenda.actions';

const groupReducer = (state = null, action) => {
    switch (action.type) {
        case GROUP_UPDATE:
            return action.value;
        case GROUP_REMOVE:
        case AGENDA_LOGGED_OUT:
            return null;
        default:
            return state;
    }
}

export default groupReducer;